require('./brokerRightsSellSidebar.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const moment = require('moment');

// @ helpers
const { getLanguage, formatText, FormattedText } = require('core/i18n').i18n;
const {
    FIRST_STEP,
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    CHARGE_ACCOUNT_PREFIX,
    EURO_TEXT,
    BROKER_TYPE_RIGHT_NEW_DECIMALS
} = require('constants/index');
const { DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');
const { RIGHTS_SELL_SHOW_COST } = require('constants/flagBasedFeatures');

// @ commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

// @components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @utilities
const DateHelper = require('utilities/dateHelper');
const { getFormattedString, formatCurrency, formatAmount, formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

class BrokerRightsSellSidebar extends React.Component {
    buildFirstStepSidebar() {
        const { immBrokerRightsSell, immCorporatesOperations } = this.props;
        const selectedCorporateOperationIndex = immBrokerRightsSell.get('selectedCorporateOperationIndex');
        const selectedCorporateOperation = immCorporatesOperations.getIn(['selectedContract', 'operations', selectedCorporateOperationIndex]);
        const closeDate = moment(selectedCorporateOperation.get('closeDate'));
        const fields = [];

        fields[fields.length] = (
            <div key={fields.length} className="broker-rights-sell-sidebar__item">
                <div className="broker-rights-sell-sidebar__item-label">
                    <FormattedText
                        value="broker-rightsSellSidebarDeadlineLabel"
                        format="uppercase"
                    />
                </div>
                <div className="broker-rights-sell-sidebar__item-name">
                    {DateHelper.buildFormattedDate(closeDate, formatText(DATE_PICKER_CUSTOM_DATE_FORMAT))}
                </div>
            </div>
        );

        return fields;
    }

    buildQuotationSection () {
        const { quotation, quotationDate, quotationTime } = this.props;
        let section;

        if (quotationTime && quotationDate) {
            const formattedDate = DateHelper.getFormattedDate(quotationDate);
            const quotationAmount = formatAmount(quotation.get('amount'), getLanguage(), BROKER_TYPE_RIGHT_NEW_DECIMALS);

            const currency = formatCurrency(EURO_TEXT); // @hardcoded

            section = (
                <div className="broker-rights-buy-sidebar__item">
                    <div className="broker-rights-buy-sidebar__item-label">
                        <FormattedText value="broker-rightsQuotation" format="uppercase" />
                    </div>
                    <div className="broker-rights-buy-sidebar__item-name">
                        {quotationAmount} {currency}
                    </div>
                    <div className="broker-rights-buy-sidebar__item-additional-information">
                        {formattedDate}, {quotationTime}
                    </div>
                </div>
            );
        } else {
            section = (
                <div className="broker-rights-buy-sidebar__item">
                    <div className="broker-rights-buy-sidebar__item-label">
                        <FormattedText value="broker-rightsQuotation" format="uppercase" />
                    </div>
                    <div className="broker-rights-buy-sidebar__item-name">
                        -
                    </div>
                </div>
            );
        }

        return section;
    }

    buildSecondStepSidebar() {
        const {
            immBrokerRightsSell,
            immCorporatesOperations,
            immFlagBasedFeatures,
        } = this.props;
        const orderTypeOption = immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'orderTypeOption']);
        const validityDate = immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'validityDate']);
        const limitedValue = immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'orderTypeValue']);

        const selectedCorporateOperationIndex = immBrokerRightsSell.get('selectedCorporateOperationIndex');
        const selectedCorporateOperation = immCorporatesOperations.getIn(['selectedContract', 'operations', selectedCorporateOperationIndex]);
        const closeDate = moment(selectedCorporateOperation.get('closeDate'));
        const rightsToSell = parseInt(immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'rightsQuantity'])) || 0;

        const fields = [];
        const formattedLimitedValue = getFormattedString({
            amount: limitedValue,
            decimalsLength: BROKER_TYPE_RIGHT_NEW_DECIMALS,
            currency: EURO_TEXT // @hardcoded
        });

        const showExAntCostRightBuy = immFlagBasedFeatures.get(RIGHTS_SELL_SHOW_COST);
        
        const estimatedBaseAmount = immBrokerRightsSell.get('estimatedBaseAmount')

        let rightsToSellValue, rightsToSellTooltip;
        if(showExAntCostRightBuy && estimatedBaseAmount) {
            const estimatedBaseAmountValue = estimatedBaseAmount.get('amount');
            const estimatedBaseAmountCurrency = estimatedBaseAmount.get('currency');
            const arrayValues = [
                rightsToSell,
                formatAmount(estimatedBaseAmountValue),
                formatCurrency(estimatedBaseAmountCurrency),
            ];
            rightsToSellValue =
                !!estimatedBaseAmountValue && !!estimatedBaseAmountCurrency
                    ? formatText('broker-rightsSellRightQuantityValue', arrayValues)
                    : rightsToSell;
            rightsToSellTooltip = (
                <OKTooltip
                    content="broker-rightsSellRightQuantityTooltip"
                    offset={[0, -15]}
                />
            );
        } else {
            rightsToSellValue = parseInt(immBrokerRightsSell.getIn(['steps', FIRST_STEP, 'rightsQuantity'])) || 0;
            rightsToSellTooltip = null;
        }


        let orderTypeText;

        switch (orderTypeOption) {
            case BROKER_ORDER_TYPE_TO_MARKET:
                orderTypeText = formatText('broker-rightsSellToMarketOrderType');
                break;
            case BROKER_ORDER_TYPE_FOR_THE_BEST:
                orderTypeText = formatText('broker-rightsSellForTheBestOrderType');
                break;
            case BROKER_ORDER_TYPE_LIMITED:
                orderTypeText = formatText('broker-rightsSellSuccessLimitedOrderType', [formattedLimitedValue]);
                break;
        }

        fields.push(
            <div className="broker-rights-buy-sidebar__item">
                <div className="broker-rights-buy-sidebar__item-label">
                    <FormattedText value="broker-broker_rightsSellRightsQuantityLabel" format="uppercase" />
                    {rightsToSellTooltip}
                </div>
                <div className="broker-rights-buy-sidebar__item-name">
                    {rightsToSellValue}
                </div>
            </div>
        );

        fields.push(
            <div key={fields.length} className="broker-rights-sell-sidebar__item">
                <div className="broker-rights-sell-sidebar__item-label">
                    <FormattedText
                        value="broker-rightsSellSidebarDeadlineLabel"
                        format="uppercase"
                    />
                </div>
                <div className="broker-rights-sell-sidebar__item-name">
                    {DateHelper.buildFormattedDate(closeDate, formatText(DATE_PICKER_CUSTOM_DATE_FORMAT))}
                </div>
            </div>
        );

        fields.push(
            <div key={fields.length} className="broker-rights-sell-sidebar__item">
                <div className="broker-rights-sell-sidebar__item-label">
                    <FormattedText
                        value="broker-rightsSellTermOfValidityLabel"
                        format="uppercase"
                    />
                </div>
                <div className="broker-rights-sell-sidebar__item-name">
                    {DateHelper.buildFormattedDate(validityDate, formatText(DATE_PICKER_CUSTOM_DATE_FORMAT))}
                </div>
            </div>
        );

        fields.push(
            <div key={fields.length} className="broker-rights-sell-sidebar__item">
                <div className="broker-rights-sell-sidebar__item-label">
                    <FormattedText value="broker-rightsSellOrderTypeLabel" format="uppercase" />
                </div>
                <div className="broker-rights-sell-sidebar__item-name">
                    {orderTypeText}
                </div>
            </div>
        );

        return fields;
    }

    buildSidebar() {
        const { immBrokerRightsSell, immCorporatesOperations, availableRights } = this.props;
        const currentStep = immBrokerRightsSell.get('visibleStep');
        const selectedCorporateOperationIndex = immBrokerRightsSell.get(
            'selectedCorporateOperationIndex'
        );
        const selectedCorporateOperation = immCorporatesOperations.getIn([
            'selectedContract',
            'operations',
            selectedCorporateOperationIndex
        ]);
        const selectedContract = immCorporatesOperations.get('selectedContract');
        const proportion = selectedCorporateOperation.get('proportion');
        const fullAccountContract = CHARGE_ACCOUNT_PREFIX + selectedContract.getIn(['cuenta', 'digitodecontrol']) + selectedContract.getIn(['cuenta', 'fullNumber']);
        const quotationSection = this.buildQuotationSection ();
        const intervention = formatText(`interventionTypes-${selectedContract.get('intervention').trim()}`);
        const plainAmountObject = getPlainAmountObject(selectedContract.getIn(['associatedAccount','balance']));
        let dynamicContent;

        switch (currentStep) {
            case WIZARD_FIRST_STEP:
                dynamicContent = this.buildFirstStepSidebar();
                break;
            case WIZARD_SECOND_STEP:
                dynamicContent = this.buildSecondStepSidebar();
                break;
        }

        return (
            <OKSectionBox>
                <div className="broker-rights-sell-sidebar">
                    <div className="broker-rights-sell-sidebar__head-item">
                        <div className="broker-rights-sell-sidebar__head-item-label">
                            <FormattedText value="broker-rightsSellValueLabel" />
                        </div>
                        <div className="broker-rights-sell-sidebar__head-item-name">
                            {selectedCorporateOperation.get('descriptionValue')}
                        </div>
                    </div>
                    {quotationSection}
                    <div className="broker-rights-sell-sidebar__item">
                        <div className="broker-rights-sell-sidebar__item-label">
                            <FormattedText
                                value="broker-rightsSellContractLabel"
                                format="uppercase"
                            />
                        </div>
                        <div className="broker-rights-sell-sidebar__item-name">
                            {selectedContract.get('walletAccountType')}
                        </div>
                        <div className="broker-rights-sell-sidebar__item-additional-information">
                            <FormattedText
                                value="broker-rightsSellSidebarContractNumber"
                                injectedStrings={[fullAccountContract]}
                            />
                        </div>
                    </div>
                    <div className="broker-rights-sell-sidebar__item">
                        <div className="broker-rights-sell-sidebar__item-label">
                            <FormattedText
                                value="broker-rightsSellSidebarHolderLabel"
                                format="uppercase"
                            />
                        </div>
                        <div className="broker-rights-sell-sidebar__item-name">
                            {selectedContract.get('owner')}
                        </div>
                        <div className="broker-rights-sell-sidebar__item-additional-information">
                            <FormattedText
                                value="broker-rightsSellInterventionLabel"
                                injectedStrings={[intervention]}
                            />
                        </div>
                    </div>
                    <div className="broker-rights-sell-sidebar__item">
                        <div className="broker-rights-sell-sidebar__item-label">
                            <FormattedText
                                value="broker-rightsSellSidebarAssociatedAccountLabel"
                                format="uppercase"
                            />
                        </div>
                        <div className="broker-rights-sell-sidebar__item-name">
                            {selectedContract.getIn(['associatedAccount', 'number'])}
                        </div>
                        <div className="broker-rights-sell-sidebar__item-additional-information">
                            <FormattedText value="broker-rightsSellBalancePrefix" />
                            <OneLineSymbolAmount
                                amountObject={plainAmountObject}
                                language={getLanguage()}
                                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                            />
                            <FormattedText value="broker-rightsSellBalanceSuffix" />
                        </div>
                    </div>
                    <div className="broker-rights-sell-sidebar__item">
                        <div className="broker-rights-sell-sidebar__item-label">
                            <FormattedText value="broker-rightsProportion" format="uppercase" />
                        </div>
                        <div className="broker-rights-sell-sidebar__item-name">
                            {proportion}
                        </div>
                    </div>
                    <div className="broker-rights-buy-sidebar__item">
                        <div className="broker-rights-buy-sidebar__item-label">
                            <FormattedText value="broker-rightsAvailables" format="uppercase" />
                        </div>
                        <div className="broker-rights-buy-sidebar__item-name">
                            {availableRights}
                        </div>
                    </div>
                    {dynamicContent}
                </div>
            </OKSectionBox>
        );
    }

    render() {
        const content = this.buildSidebar();

        return content;
    }
}

BrokerRightsSellSidebar.propTypes = {
    availableRights: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    immBrokerRightsSell: PropTypes.object.isRequired,
    immCorporatesOperations: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    quotation: PropTypes.object.isRequired,
    quotationTime: PropTypes.string.isRequired,
    quotationDate: PropTypes.string.isRequired
}

module.exports = BrokerRightsSellSidebar;
